<template>

    <div v-show="Visible" class="calc-overlay">

        <div class="calc-popup">

            <!-- FEJLÉC -->
            <div class="calc-header">

                <span>
                    <i class="fal fa-calculator" style="margin-right:8px;"></i>
                    Befizetés kalkulátor
                </span>

                <span class="calc-close" @click="Close">
                    <i class="fal fa-times"></i>
                </span>

            </div>


            <!-- 1. LAP -->
            <div v-show="Page == 1" class="calc-content">


                <!-- BEFIZETENDŐ ÖSSZEG -->
                <GrcNum
                    ref="txtCalcBefizetes"
                    v-model="txtCalcBefizetes"
                    grc_labeltext="Ennyit szeretnék befizetni:"
                    grc_placeholder="..."
                    grc_currency="Ft"
                    grc_decimalplaces="0"
                    grc_readonly="false"
                    grc_textalign="left"
                    grc_labelmode="above"
                    grc_labelwidth="200px"
                    v-on:grc-keydown="ClearError"
                    style="margin-bottom:20px;"
                />


                <div class="calc-vagy">
                    - vagy -
                </div>


                <!-- EGYÉNI SZÁMLÁRA KERÜLŐ ÖSSZEG -->
                <GrcNum
                    ref="txtCalcEgyeniSzamla"
                    v-model="txtCalcEgyeniSzamla"
                    grc_labeltext="Ennyi kerüljön az egyéni számlámra:"
                    grc_placeholder="..."
                    grc_currency="Ft"
                    grc_decimalplaces="0"
                    grc_readonly="false"
                    grc_textalign="left"
                    grc_labelmode="above"
                    grc_labelwidth="200px"
                    v-on:grc-keydown="ClearError"
                    style="margin-bottom:25px;"
                />


                <!-- HIBAÜZENET -->
                <div v-show="ErrorText != ''" class="calc-error">

                    <i class="fal fa-exclamation-circle"></i>

                    <span>
                        {{ ErrorText }}
                    </span>

                </div>


                <!-- TOVÁBB -->
                <div class="calc-buttons">

                    <span
                        class="cms_linkbutton cms_linkbutton_2"
                        style="margin:4px 8px;"
                        @click="Tovabb"
                    >
                        <span>
                            Tovább
                            <i
                                class="fal fa-angle-double-right"
                                style="margin-left:10px;"
                            ></i>
                        </span>
                    </span>

                </div>

            </div>


            <!-- 2. LAP -->
            <div v-show="Page == 2" class="calc-content">


                <!-- BEFIZETENDŐ ÖSSZEG -->
                <div class="calc-result-row" style="padding-top:0px;">

                    <div class="calc-result-label">
                        Befizetendő összeg:
                    </div>

                    <div class="calc-result-value">
                        {{ FormatNumber(Calc_Befizetes) }} Ft
                    </div>

                </div>


                <!-- EGYÉNI SZÁMLÁRA KERÜLŐ ÖSSZEG -->
                <div class="calc-result-row">

                    <div class="calc-result-label">
                        Ebből az egyéni számlájára kerül:
                    </div>

                    <div class="calc-result-value">
                        {{ FormatNumber(Calc_EgyeniSzamla) }} Ft
                    </div>

                </div>


                <!-- INFORMÁCIÓ -->
                <div class="calc-info">

                    <template v-if="Calc_BelepesiDij > 0">

                        A befizetésből levonásra kerül 
                        <b>{{ FormatNumber(Calc_BelepesiDij) }} Ft</b>
                        belépési díj.

                        <br><br>

                        A fennmaradó összeg
                        <b>{{ Calc_FedSzazalek }}%-a</b>
                        kerül az egyéni számlára.

                    </template>


                    <template v-else>

                        A befizetendő összeg
                        <b>{{ Calc_FedSzazalek }}%-a</b>
                        kerül az egyéni számlára.

                    </template>

                </div>


                <!-- GOMBOK -->
                <div class="calc-buttons">

                    <span
                        class="cms_linkbutton cms_linkbutton_BLUE"
                        style="margin:4px 8px;"
                        @click="Vissza"
                    >
                        <span>
                            <i
                                class="fal fa-angle-double-left"
                                style="margin-right:10px;"
                            ></i>
                            Vissza
                        </span>
                    </span>


                    <span
                        class="cms_linkbutton cms_linkbutton_2"
                        style="margin:4px 8px;"
                        @click="SetValue"
                    >
                        <span>
                            <i
                                class="fal fa-check"
                                style="margin-right:10px;"
                            ></i>
                            Összeg beállítása
                        </span>
                    </span>

                </div>

            </div>

        </div>

    </div>

</template>


<script>

import GrcNum from '../GrcComponents/GrcNum.vue'


export default {

    name: 'CalcPopup',


    components: {

        GrcNum

    },


    data () {

        return {

            Visible: false,

            Page: 1,

            ErrorText: "",


            Calc_BelepesiDij: 0,

            Calc_FedSzazalek: 0,


            Calc_Befizetes: 0,

            Calc_EgyeniSzamla: 0,

            txtCalcBefizetes:0,
            txtCalcEgyeniSzamla:0


        }

    },


    methods: {


        Show(pBelepesiDij, pFedSzazalek)
        {

            this.Calc_BelepesiDij =
                Number(pBelepesiDij);


            this.Calc_FedSzazalek =
                Number(pFedSzazalek);


            if (isNaN(this.Calc_BelepesiDij))
            {
                this.Calc_BelepesiDij = 0;
            }


            if (isNaN(this.Calc_FedSzazalek))
            {
                this.Calc_FedSzazalek = 0;
            }


            this.Calc_Befizetes = 0;

            this.Calc_EgyeniSzamla = 0;

            this.ErrorText = "";

            this.Page = 1;

            this.Visible = true;


            this.$nextTick(() => {

                this.$refs.txtCalcBefizetes.SetValue(0);

                this.$refs.txtCalcEgyeniSzamla.SetValue(0);

            });

        },




        Close()
        {

            this.ErrorText = "";

            this.Visible = false;

        },




        ClearError()
        {

            this.ErrorText = "";

        },




        Vissza()
        {

            this.ErrorText = "";

            this.Page = 1;

        },




        Tovabb()
        {

            this.ErrorText = "";


            let pBefizetes =
                Number(
                    this.$refs.txtCalcBefizetes.GetValue()
                );


            let pEgyeniSzamla =
                Number(
                    this.$refs.txtCalcEgyeniSzamla.GetValue()
                );


            if (isNaN(pBefizetes))
            {
                pBefizetes = 0;
            }


            if (isNaN(pEgyeniSzamla))
            {
                pEgyeniSzamla = 0;
            }



            /*
                NEGATÍV ÖSSZEG
            */

            if (
                (pBefizetes < 0) ||
                (pEgyeniSzamla < 0)
            )
            {

                this.ErrorText =
                    "Negatív összeg nem adható meg!";

                return;

            }



            /*
                EGYIK ÖSSZEG SINCS MEGADVA
            */

            if (
                (pBefizetes == 0) &&
                (pEgyeniSzamla == 0)
            )
            {

                this.ErrorText =
                    "Kérjük, adja meg, hogy mennyit szeretne befizetni, vagy mennyi kerüljön az egyéni számlájára!";

                return;

            }



            /*
                MINDKÉT ÖSSZEG MEG VAN ADVA
            */

            if (
                (pBefizetes > 0) &&
                (pEgyeniSzamla > 0)
            )
            {

                this.ErrorText =
                    "Egyszerre csak az egyik összeg adható meg!";

                return;

            }



            /*
                FEDEZETI SZÁZALÉK ELLENŐRZÉSE
            */

            if (
                (this.Calc_FedSzazalek <= 0) ||
                (this.Calc_FedSzazalek > 100)
            )
            {

                this.ErrorText =
                    "A kalkulátor beállítása hibás!";

                return;

            }



            /*
                =========================================
                BEFIZETÉSI ÖSSZEGBŐL SZÁMOLUNK
                =========================================

                1. Levonjuk a belépési díjat.
                2. Kiszámoljuk a fedezeti százalékot.
                3. Matematikailag kerekítünk.
            */

            if (pBefizetes > 0)
            {

                if (
                    pBefizetes <
                    this.Calc_BelepesiDij
                )
                {

                this.ErrorText =
                    "Minimum " +
                    this.FormatNumber(this.Calc_BelepesiDij) +
                    " Ft belépési díj befizetése kötelező!";

                    return;

                }


                this.Calc_Befizetes =
                    pBefizetes;


                this.Calc_EgyeniSzamla =
                    Math.round(

                        (
                            pBefizetes -
                            this.Calc_BelepesiDij
                        )

                        *

                        (
                            this.Calc_FedSzazalek /
                            100
                        )

                    );

            }



            /*
                =========================================
                EGYÉNI SZÁMLA ÖSSZEGBŐL SZÁMOLUNK
                =========================================

                Olyan egész forint befizetési összeget
                keresünk, amelyből az előrefelé történő
                számítás után pontosan a felhasználó által
                megadott összeg kerül az egyéni számlára.

                Tehát ugyanazt a Math.round() szabályt
                ellenőrizzük visszafelé is.
            */

            if (pEgyeniSzamla > 0)
            {

                let pFedArany =
                    this.Calc_FedSzazalek / 100;


                /*
                    Első közelítés:
                    visszaszámoljuk a fedezeti százalékból
                    a nettó befizetési összeget.
                */

                let pNettoBefizetes =
                    Math.round(
                        pEgyeniSzamla /
                        pFedArany
                    );


                /*
                    Ellenőrizzük ugyanazzal a szabállyal,
                    amivel előrefelé is számolunk.
                */

                let pEllenorzes =
                    Math.round(
                        pNettoBefizetes *
                        pFedArany
                    );


                /*
                    Ha az első közelítés 1 Ft-tal
                    alacsonyabb eredményt ad,
                    növeljük a nettó befizetést.
                */

                if (pEllenorzes < pEgyeniSzamla)
                {

                    pNettoBefizetes++;

                }


                /*
                    Ha az első közelítés 1 Ft-tal
                    magasabb eredményt ad,
                    csökkentjük a nettó befizetést.
                */

                else if (pEllenorzes > pEgyeniSzamla)
                {

                    pNettoBefizetes--;

                }


                /*
                    Újra ellenőrizzük, hogy az így
                    meghatározott befizetés valóban
                    pontosan a kívánt összeget adja.
                */

                pEllenorzes =
                    Math.round(
                        pNettoBefizetes *
                        pFedArany
                    );


                if (pEllenorzes != pEgyeniSzamla)
                {

                    this.ErrorText =
                        "A megadott összeghez nem határozható meg pontos befizetési összeg!";

                    return;

                }


                /*
                    Az eredményként megjelenített
                    egyéni számla összeg pontosan
                    a felhasználó által megadott érték.
                */

                this.Calc_EgyeniSzamla =
                    pEgyeniSzamla;


                /*
                    A nettó befizetéshez hozzáadjuk
                    a belépési díjat.
                */

                this.Calc_Befizetes =
                    pNettoBefizetes
                    +
                    this.Calc_BelepesiDij;

            }



            /*
                EREDMÉNY OLDAL
            */

            this.Page = 2;

        },




        SetValue()
        {

            this.$emit(
                "setvalue",
                this.Calc_Befizetes
            );


            this.Close();

        },




        FormatNumber(pValue)
        {

            /*
                Szóközös ezres tagolás:

                3223       -> 3 223
                10000      -> 10 000
                1234567    -> 1 234 567
            */

            if (
                (pValue == null) ||
                (isNaN(pValue))
            )
            {
                return "0";
            }


            return Math.round(
                Number(pValue)
            )
            .toString()
            .replace(
                /\B(?=(\d{3})+(?!\d))/g,
                " "
            );

        }


    }

}

</script>


<style scoped>


/*
    TELJES KÉPERNYŐS HÁTTÉR
*/

.calc-overlay
{
    position:fixed;

    left:0;

    top:0;

    width:100%;

    height:100%;

    z-index:10000;

    background:rgba(0,0,0,0.45);

    display:flex;

    align-items:center;

    justify-content:center;

    box-sizing:border-box;

    padding:20px;
}



/*
    POPUP
*/

.calc-popup
{
    width:100%;

    max-width:520px;

    background:#fff;

    box-sizing:border-box;

    border-radius:15px;

    box-shadow:
        0px 5px 25px rgba(0,0,0,0.25);

    overflow:hidden;
}



/*
    FEJLÉC
*/

.calc-header
{
    width:100%;

    box-sizing:border-box;

    padding:18px 20px;

    font-size:20px;

    font-weight:500;

    color:var(--themecolor3);

    border-bottom:1px solid #ddd;

    display:flex;

    align-items:center;

    justify-content:space-between;
}



.calc-close
{
    cursor:pointer;

    font-size:22px;

    line-height:22px;

    color:#777;

    padding:3px;
}



.calc-close:hover
{
    color:#000;
}



/*
    TARTALOM
*/

.calc-content
{
    width:100%;

    box-sizing:border-box;

    padding:25px;
}



/*
    "VAGY"
*/

.calc-vagy
{
    width:100%;

    text-align:center;

    font-size:16px;

    font-weight:500;

    margin:
        5px
        0px
        20px
        0px;

    color:#555;
}



/*
    HIBAÜZENET
*/

.calc-error
{
    width:100%;

    box-sizing:border-box;

    margin:
        5px
        0px
        15px
        0px;

    padding:12px 15px;

    border:1px solid #d9534f;

    border-radius:4px;

    background:#fff5f5;

    color:#b52b27;

    font-size:14px;

    line-height:20px;

    display:flex;

    align-items:flex-start;
}



.calc-error i
{
    flex:none;

    margin-right:8px;

    margin-top:2px;

    font-size:16px;
}



/*
    GOMBOK
*/

.calc-buttons
{
    width:100%;

    box-sizing:border-box;

    text-align:center;

    margin-top:15px;
}



/*
    EREDMÉNY SOROK
*/

.calc-result-row
{
    width:100%;

    box-sizing:border-box;

    padding:14px 0px;

    border-bottom:1px solid #eee;
}



.calc-result-label
{
    display:inline-block;

    width:60%;

    box-sizing:border-box;

    vertical-align:middle;

    font-size:16px;
}



.calc-result-value
{
    display:inline-block;

    width:40%;

    box-sizing:border-box;

    vertical-align:middle;

    text-align:right;

    font-size:19px;

    font-weight:600;

    color:var(--themecolor3);
}



/*
    INFORMÁCIÓS DOBOZ
*/

.calc-info
{
    width:100%;

    box-sizing:border-box;

    margin-top:25px;

    padding:15px;

    background:#f5f5f5;

    font-size:14px;

    line-height:20px;
}



/*
    MOBIL - 500px ALATT

    A címke balra marad,
    az összeg középre kerül.
*/

@media screen and (max-width:500px)
{

    .calc-overlay
    {
        padding:10px;
    }


    .calc-popup
    {
        max-width:100%;
    }


    .calc-header
    {
        padding:15px;
    }


    .calc-content
    {
        padding:20px 15px;
    }


    .calc-result-label
    {
        width:100%;

        display:block;

        text-align:left;
    }


    .calc-result-value
    {
        width:100%;

        display:block;

        text-align:center;

        margin-top:8px;
    }


    .calc-error
    {
        padding:10px 12px;
    }

}


</style>